<script setup lang="ts">
defineProps({
    contentHeadlineConfig: {
        type: Object,
        required: false,
        default: () => ({}),
        validator: (rawValue) => {
            return typeof rawValue?.title === 'string'
        }
    }
})
</script>

<template>
    <h2 class="content-headline" v-html="contentHeadlineConfig?.title" />
</template>

<style  lang="scss">
.content-headline {
    @include main-headline;
}
</style>
